module.exports = __webpack_public_path__ + "static/media/ke_background.2e039656.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/ke_background.png
// module id = 2643
// module chunks = 0